// component
import { useSelector } from 'react-redux';
import { t } from 'i18next';
import account from '../../../_mock/account';
import SvgColor from '../../../components/svg-color';
import Translate from '../../../utils/Translate';
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const icon = (name, png = false, w = 1, h = 1) => (
  <SvgColor src={`/assets/icons/navbar/${name}.${png ? 'png' : 'svg'}`} sx={{ width: w, height: h }} />
);

const onlineBadge = <span className="w-3 h-3 bg-green-500 rounded-full mr-5 animate-pulse" title="yangi xabar" />;

const ROUTES = [
  {
    title: (
      <Translate
        dictionary={{
          uz: 'Buyurtmalar',
          ru: 'Заказы',
        }}
      />
    ),
    path: '/dashboard/orders',
    icon: icon('ic_orders'),
    roles: ['VENDOR', 'COURIER'],
    children: [
      {
        title: (
          <Translate
            dictionary={{
              uz: 'Buyurtmalar',
              ru: 'Заказы',
            }}
          />
        ),
        path: '/dashboard/orders/all',
        icon: <Iconify icon="mdi:shopping-outline" />,
      },
      {
        title: (
          <Translate
            dictionary={{
              uz: 'Arxiv buyurtmalar',
              ru: 'Архив заказов',
            }}
          />
        ),
        path: '/dashboard/orders/archive',
        icon: <Iconify icon="ic:round-archive" width={24} height={24} />,
      },
    ],
  },
  // {
  //   title: (
  //     <Translate
  //       dictionary={{
  //         uz: 'Arizalar',
  //         ru: 'Приложения',
  //       }}
  //     />
  //   ),
  //   path: '/dashboard/requests',
  //   icon: icon('ic_requests'),
  //   roles: ['VENDOR', 'COURIER'],
  // },
  {
    title: (
      <Translate
        dictionary={{
          uz: 'Statistika',
          ru: 'Статистика',
        }}
      />
    ),
    path: '/dashboard/app',
    icon: icon('ic_analytics'),
    roles: ['ADMIN', 'VENDOR'],
  },
  {
    title: (
      <Translate
        dictionary={{
          uz: 'Mijozlar',
          ru: 'Клиенты',
        }}
      />
    ),
    path: '/dashboard/clients',
    icon: icon('ic_clients'),
    roles: ['ADMIN', 'VENDOR'],
  },
  {
    title: (
      <Translate
        dictionary={{
          uz: 'Sotuvchilar',
          ru: 'Продавцы',
        }}
      />
    ),
    path: '/dashboard/vendors',
    icon: icon('ic_vendor'),
    roles: ['ADMIN'],
  },
  {
    title: (
      <Translate
        dictionary={{
          uz: 'Mahsulotlar',
          ru: 'Продукты',
        }}
      />
    ),
    path: '/dashboard/products',
    icon: <Iconify icon="mdi:cart-outline" />,
    roles: ['ADMIN'],
  },
  // {
  //   title: (
  //     <Translate
  //       dictionary={{
  //         uz: 'Hamkorlar',
  //         ru: 'Партнеры',
  //       }}
  //     />
  //   ),
  //   path: '/dashboard/partners',
  //   info: <span className="text-blue-500 mr-5">15</span>,
  //   icon: icon('ic_clients'),
  //   roles: ['ADMIN'],
  // },

  {
    title: (
      <Translate
        dictionary={{
          uz: 'Kuryerlar',
          ru: 'Курьеры',
        }}
      />
    ),
    path: '/dashboard/couriers',
    icon: icon('ic_couriers'),
    roles: ['VENDOR'],
  },
  // {
  //   title: (
  //     <Translate
  //       dictionary={{
  //         uz: 'Vakansiyalar',
  //         ru: 'Вакансии',
  //       }}
  //     />
  //   ),
  //   path: '/dashboard/vacancies',
  //   icon: icon('ic_vacancies', false, 28, 28),
  //   roles: ['VENDOR'],
  // },
  // {
  //   title: (
  //     <Translate
  //       dictionary={{
  //         uz: 'Izohlar',
  //         ru: 'Примечания',
  //       }}
  //     />
  //   ),
  //   path: '/dashboard/notes',
  //   info: onlineBadge,
  //   icon: icon('ic_notes'),
  //   roles: ['ADMIN', 'VENDOR'],
  // },

  {
    title: (
      <Translate
        dictionary={{
          uz: 'Bannerlar',
          ru: 'Баннеры',
        }}
      />
    ),
    path: '/dashboard/banners',
    icon: <Iconify icon="mdi:format-list-bulleted" />,
    roles: ['ADMIN'],
  },
  {
    title: (
      <Translate
        dictionary={{
          uz: 'Aksiyalar',
          ru: 'Акции',
        }}
      />
    ),
    path: '/dashboard/promotions',
    icon: <Iconify icon="mdi:tag-outline" />,
    roles: ['VENDOR'],
  },
  {
    title: (
      <Translate
        dictionary={{
          uz: 'SMS yuborish',
          ru: 'Отправить SMS',
        }}
      />
    ),
    path: '/dashboard/sms',
    icon: <Iconify icon="mdi:message-text-outline" />,
    roles: ['VENDOR'],
  },
  // {
  //   title: (
  //     <Translate
  //       dictionary={{
  //         uz: 'Chat',
  //         ru: 'Чат',
  //       }}
  //     />
  //   ),
  //   path: '/dashboard/chat',
  //   icon: icon('ic_chat', true),
  //   roles: ['VENDOR'],
  // },
  {
    title: (
      <Translate
        dictionary={{
          uz: 'Sozlamalar',
          ru: 'Настройки',
        }}
      />
    ),
    path: `/dashboard/settings`,
    icon: icon('ic_settings'),
    roles: ['VENDOR'],
  },
  // {
  //   title: (
  //     <Translate
  //       dictionary={{
  //         uz: 'Boshqaruv',
  //         ru: 'Управление',
  //       }}
  //     />
  //   ),
  //   path: `/dashboard/control`,
  //   icon: icon('ic_control'),
  //   roles: ['ADMIN'],
  // },
];

const navConfig = (role, { ordersCount = 0, applicationsCount = 0 } = {}) => {
  return ROUTES.map((route) => {
    if (route.path === '/dashboard/orders' && ordersCount > 0) {
      return {
        ...route,
        info: <span className="bg-green-500 py-0.5 px-1.5 rounded-full text-xs text-white mr-5">{ordersCount}</span>,
      };
    }
    if (route.path === '/dashboard/requests' && applicationsCount > 0) {
      return { ...route, info: <span className="text-red-500 mr-5">{applicationsCount}</span> };
    }
    return route;
  }).filter((route) => route.roles.includes(role));
};

export default navConfig;
